// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from "./http/http"
import "babel-polyfill" //解决Ie白屏问题对es6语法不支持
import JsEncrypt from "jsencrypt"//RSA加密
import Cookies from 'js-cookie'
import layer from "layui-layer";
import {
  Pagination,
  Carousel,
  CarouselItem,
  Loading,
  Form,
  FormItem,
  Input,
  Button,
  Select,
  Option,
  OptionGroup,
  ButtonGroup,
  Col,
  Row,
  DatePicker,
  TimePicker,
  Switch,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Steps,
  Step,
  Cascader,
  Upload,
  Table,
  TableColumn,
  Autocomplete,
  Calendar,
  Popover 
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/base.styl'
import qs from 'qs'
let Base64 = require('js-base64').Base64;//引入base64对地址栏参数进行加密
Vue.prototype.$http=axios
Vue.prototype.$Cookies=Cookies
Vue.prototype.$qs = qs
Vue.prototype.$layer = layer
Vue.prototype.$jsEncrypt = function (parms) {
  let encrypt = new JSEncrypt();
  encrypt.setPublicKey("MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCK4n2xrbtnRyBqMJ2iiDeDRdJ/F8EVmzcjSGy/vVNfEVahl6sQOjQXZTc8AEbiZdyLnP9QwX3ZkIsEGUz1VMaPUJeHLHQC5uVljRWR0ORt4oiU7mtN5ZsEl8gPQBzSbC7IpnXVRN1Mx7s/RlFsWZgkuZKbPjxcfgoA9zXyhmcHywIDAQAB");
  let data = encrypt.encrypt(parms);
  return data;
}
Vue.config.productionTip = false
Vue.use( Pagination)
Vue.use( Carousel)
Vue.use( CarouselItem)
Vue.use( Loading)
Vue.use( Form)
Vue.use( FormItem)
Vue.use( Input)
Vue.use( Button)
Vue.use( Select)
Vue.use( Option)
Vue.use( OptionGroup)
Vue.use( ButtonGroup)
Vue.use( Col)
Vue.use( Row)
Vue.use( DatePicker)
Vue.use( TimePicker)
Vue.use( Radio)
Vue.use( RadioGroup)
Vue.use( RadioButton)
Vue.use( Checkbox)
Vue.use( CheckboxButton)
Vue.use( CheckboxGroup)
Vue.use( Switch)
Vue.use( Steps)
Vue.use( Step)
Vue.use( Cascader)
Vue.use( Upload)
Vue.use( Table)
Vue.use( TableColumn)
Vue.use( Autocomplete)
Vue.use( Calendar)
Vue.use( Popover )
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js